import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

export default function EditIcon() {
  return <FontAwesomeIcon icon={faEdit} />
}
